import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=e8b7c038&scoped=true&"
import script from "./CampaignDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetails.vue?vue&type=style&index=0&id=e8b7c038&scoped=true&lang=scss&"
import style1 from "./CampaignDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b7c038",
  null
  
)

export default component.exports